import Vue from 'vue';
export const EventBus = new Vue();
// import store from "../stores/AppStore";

EventBus.$on('eventUpdate', eventUpdate);

async function eventUpdate(e) {
  console.log(e);
  // let IntercomUserID = this.$cookies.get("intercom-id-wad8d6ha");

  // if (this.$intercomMessage) {
  //   if (e.time > 0) {
  //     clearTimeout(this.t);
  //     console.log("event msg", e.params.msg);

  //     this.t = setTimeout(() => {
  //       console.log("time", e.time);
  //       let params = {
  //         user_id: IntercomUserID,
  //         msg: e.params.msg,
  //       };
  //       store
  //         .dispatch("SEND_MESSAGE", params)
  //         .then((result) => {
  //           console.log("result", result);
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });
  //     }, e.time * 1000);
  //   } else {
  //     console.log("Clear Message");

  //     clearTimeout(this.t);
  //   }
  // } else {
  //   let msg = e.params ? e.params.msg : e;
  //   console.log("Developement not sending intercom messages", msg);
  //   console.log("User ID Intercom", IntercomUserID);
  // }
}
